module.exports = __webpack_public_path__ + "img/Wp_2037.b1dcd0ca.png";